// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-chart-settings__settings .center-setting {
  --gc-form-row-label-width: 140px;
}
.wizard-chart-settings__settings .center-setting__input {
  width: 170px;
  margin-left: 12px;
  display: inline-block;
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/CenterSetting/CenterSetting.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;AACI;EACI,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AACR","sourcesContent":[".wizard-chart-settings__settings .center-setting {\n  --gc-form-row-label-width: 140px;\n}\n.wizard-chart-settings__settings .center-setting__input {\n  width: 170px;\n  margin-left: 12px;\n  display: inline-block;\n  vertical-align: top;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
